import React, { useEffect, useState } from 'react';
import MatchSheet from './MatchSheet';

/**
 * Tactic sheet. The six existing tactics render as radio option cards showing
 * the hint and the trade-off up front, instead of hiding them behind a
 * dropdown selection.
 */
function TacticSheet({ isOpen, onClose, tactics = [], activeTacticId, onConfirm }) {
    const [selectedTacticId, setSelectedTacticId] = useState(activeTacticId);

    useEffect(() => {
        setSelectedTacticId(activeTacticId);
    }, [activeTacticId, isOpen]);

    const selectedTactic = tactics.find((tactic) => tactic.id === selectedTacticId);

    return (
        <MatchSheet
            isOpen={isOpen}
            onClose={onClose}
            title="CHANGE TACTIC"
            popupClassName="tactic-popup"
            footer={(
                <button
                    type="button"
                    className="mx-confirm-btn"
                    onClick={() => onConfirm(selectedTacticId)}
                    disabled={!selectedTacticId}
                    aria-label="CONFIRM"
                >
                    <span className="mx-confirm-btn__label">CONFIRM</span>
                    <span className="mx-confirm-btn__sub">
                        {selectedTactic ? selectedTactic.title : 'Select a tactic'}
                    </span>
                </button>
            )}
        >
            {tactics.map((tactic) => {
                const isSelected = tactic.id === selectedTacticId;
                const isCurrent = tactic.id === activeTacticId;

                return (
                    <button
                        key={tactic.id}
                        type="button"
                        className={`mx-topt${isSelected ? ' is-selected' : ''}`}
                        onClick={() => setSelectedTacticId(tactic.id)}
                        aria-label={tactic.title}
                        aria-pressed={isSelected}
                    >
                        <span className="mx-topt__name">
                            {tactic.title}
                            {isCurrent && <span className="mx-topt__current">CURRENT</span>}
                        </span>
                        {tactic.properties && (
                            <span className="mx-topt__hint">
                                <b>Hint:</b> {tactic.properties.advantages}
                                <br />
                                <i>Trade-off:</i> {tactic.properties.flaws}
                            </span>
                        )}
                        <span className="mx-topt__radio" aria-hidden="true" />
                    </button>
                );
            })}
        </MatchSheet>
    );
}

export default TacticSheet;
